import { createContext, useContext } from 'react';
import { type GoogleMaps } from './types';

export const GoogleMapsContext = createContext<GoogleMaps | undefined>(undefined);

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
